export default __webpack_public_path__ + "static/media/blogImage1.ac7dda16.png";